function OnlyNumberDirective($parse, $filter) {
    return {
        require: 'ngModel',
        priority: 1,
        link: function (scope, element, attr, ctrl) {

            function formatViewValue() {
                ctrl.$viewValue = $filter('number')(ctrl.$modelValue);
                ctrl.$render();
            }

            function parser(value) {
                if (!(_.isUndefined(value) || _.isNull(value))) {
                    var transformedInput = value.toString().replace(/[^0-9]/g, '');
                    if (transformedInput !== value) {
                        ctrl.$setViewValue(transformedInput);
                        formatViewValue();
                    }

                    var intValue = parseInt(transformedInput);
                    var min = (!_.isUndefined(attr.min)) ? $parse(attr.min)(scope) : Number.NaN;
                    var max = (!_.isUndefined(attr.max)) ? $parse(attr.max)(scope) : Number.NaN;

                    ctrl.$setValidity('min', (_.isNaN(min)) ? true : intValue >= min);
                    ctrl.$setValidity('max', (_.isNaN(max)) ? true : intValue <= max);

                    return transformedInput;
                }
                return "";
            }

            ctrl.$parsers.push(parser);

            scope.$watch(function () {
                return ctrl.$modelValue;
            }, function (newVal, oldVal) {
                formatViewValue();
            });
        }
    };
}

OnlyNumberDirective.$inject = ['$parse', '$filter'];

module.exports = OnlyNumberDirective;